/**
 * @generated SignedSource<<cd1ba4d0c169d7eeaaeeb31d95c47369>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SelectSecondaryScheduleTypeDimension_integrationTilTid$data = {
  readonly id: string;
  readonly secondaryScheduleTypeOption: {
    readonly id: string;
    readonly name: string;
    readonly providerId: string;
  } | null;
  readonly secondaryScheduleTypeOptions: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly providerId: string;
  }>;
  readonly " $fragmentType": "SelectSecondaryScheduleTypeDimension_integrationTilTid";
};
export type SelectSecondaryScheduleTypeDimension_integrationTilTid$key = {
  readonly " $data"?: SelectSecondaryScheduleTypeDimension_integrationTilTid$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectSecondaryScheduleTypeDimension_integrationTilTid">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "providerId",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectSecondaryScheduleTypeDimension_integrationTilTid",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationTilTidSecondaryScheduleTypeOption",
      "kind": "LinkedField",
      "name": "secondaryScheduleTypeOptions",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IntegrationTilTidSecondaryScheduleTypeOption",
      "kind": "LinkedField",
      "name": "secondaryScheduleTypeOption",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "IntegrationTilTid",
  "abstractKey": null
};
})();

(node as any).hash = "f9e6dbf95954e673769b5332b50dd1cb";

export default node;
